var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel } from "@mui/material";
import { forwardRef } from "react";
import { useStyles } from "./ui_form_control_label.css";
export const UiFormControlLabel = forwardRef((_a, ref) => {
    var { label, subLabel } = _a, props = __rest(_a, ["label", "subLabel"]);
    const classes = useStyles();
    return (_jsx(FormControlLabel, Object.assign({ ref: ref, label: _jsxs(_Fragment, { children: [_jsx("div", { className: classes.label__main, children: label }), subLabel !== undefined && (_jsx("div", { className: classes.label__sub, children: subLabel }))] }) }, props)));
});
//# sourceMappingURL=ui_form_control_label.js.map